export const AWAITING_CONFIRMATION_MESSAGE =
  "Your order is saved and awaiting confirmation. You can return to Ordering. Do not enter it again; the ordering team needs to check its confirmation.";

const HELD_CODES = new Set([
  "BC_RECONCILIATION_REQUIRED",
  "BC_CONFIRMATION_PENDING",
  "BC_SUBMISSION_PAUSED",
]);

/** Only a receipt for this exact saved order may bypass ordinary error handling. */
export function isSavedAwaitingConfirmation(
  value: unknown,
  expectedOrderId?: string,
): boolean {
  if (!value || typeof value !== "object" || !expectedOrderId) return false;
  const receipt = value as {
    success?: boolean;
    code?: string;
    data?: {
      orderId?: string;
      status?: string;
      requiresReconciliation?: boolean;
      bcSalesOrderNo?: string;
    };
  };
  return (
    receipt.success === false &&
    HELD_CODES.has(receipt.code || "") &&
    typeof receipt.data?.orderId === "string" &&
    receipt.data.orderId.toLowerCase() === expectedOrderId.toLowerCase() &&
    receipt.data.status === "PENDING_BC_SYNC" &&
    receipt.data.requiresReconciliation === true &&
    !receipt.data.bcSalesOrderNo
  );
}
